import { createDecorator } from '../../instantiation/common/instantiation.js';
const IUpdateService = ( createDecorator('updateService'));
export { IUpdateService };
